import APP_CONSTANTS from "../constants";

const apiRoute = APP_CONSTANTS.apiUrl + "/api/v4";

export const searchPatientsApiRoute = `${apiRoute}/pms/searchPatients`; // done in backend-upgrade

export const verifyEmailPassAPI = `${apiRoute}/doctor/verify-email-pass`; // ERX requirement

// export const getStateListApiRoute = `${apiRoute}/getStateList`; // done in backend-upgrade
export const getConstansApiRoute = `${apiRoute}/constants`; // done in backend-upgrade
export const accessTokenLoginApiRoute = `${apiRoute}/pms/accessTokenLogin`; // done in backend-upgrade

export const getPatientByIdApiRoute = `${apiRoute}/pms/getPatientById`; // done in backend-upgrade
export const getConsultNotesApiRoute = `${apiRoute}/pms/getConsultNotes`; // done in backend-upgrade
export const sendConsultNoteToPatientApiRoute = `${apiRoute}/pms/sendConsultNoteToPatient`; // done in backend-upgrade
export const cancelAttachmentApiRoute = `${apiRoute}/pms/cancelAttachment`; // done in backend-upgrade
export const cancelPrescriptionApiRoute = `${apiRoute}/pms/cancelPrescription`; // done in backend-upgrade  //! NOT TESTED YET
export const ceaseEPrescribingApiRoute = `${apiRoute}/pms/ceaseEPrescribing`; // done in backend-upgrade  //! NOT TESTED YET
export const reissueEPrescribingApiRoute = `${apiRoute}/pms/reissueEPrescribing`; // done in backend-upgrade  //! NOT TESTED YET
export const previouslyPrescribedApiRoute = `${apiRoute}/pms/drug/previousprescribed`; // done in backend-upgrade  //! NOT TESTED YET
// todo change to previousPrescribed

export const deleteConsultNoteDataApiRoute = `${apiRoute}/pms/deleteConsultNoteData`; // done in backend-upgrade //! NOT TESTED YET
export const sendEmailToPharmacyApiRoute = `${apiRoute}/pms/sendEmailToPharmacy`; // done in backend-upgrade //! NOT TESTED YET
export const sendCustomNoteApiRoute = `${apiRoute}/pms/SendCustomNote`; // done in backend-upgrade //! NOT TESTED YET

export const editPatientProfileApiRoute = `${apiRoute}/pms/editPatientProfile`; // done in backend-upgrade

export const addPatientRecordLogApiRoute = `${apiRoute}/admin/addPatientRecordLog`; // done in backend-upgrade
export const getPatientAccessLogApiRoute = `${apiRoute}/pms/getPatientAccessLog`; // done in backend-upgrade

export const sendNotificationsApiRoute = `${apiRoute}/admin/sendNotifications`; // done in backend-upgrade //! NOT TESTED YET

export const mergePatientRecordApiRoute = `${apiRoute}/admin/mergePatientRecord`; // done in backend-upgrade //! NOT TESTED YET

export const addConsultNoteStep1ApiRoute = `${apiRoute}/pms/addConsultNoteStep1`; // done in backend-upgrade //! NOT TESTED YET
export const addConsultNoteStep2ApiRoute = `${apiRoute}/pms/addConsultNoteStep2`; // done in backend-upgrade //! NOT TESTED YET

export const createTicketFromPMSApiRoute = `${apiRoute}/pms/createTicketFromPMS`; // done in backend-upgrade //! NOT TESTED YET

export const searchPharmacyDetailApiRoute = `${apiRoute}/pms/searchPharmacyDetail`; // done in backend-upgrade //! NOT TESTED YET

export const accessMIMSTokenApiRoute = `${apiRoute}/pms/accessMIMSToken`; // done in backend-upgrade

export const getProductsByIngredientApiRoute = `${apiRoute}/pms/getProductsByIngredient`; // done in backend-upgrade

export const getProductsByBrandApiRoute = `${apiRoute}/pms/getProductsByBrand`; // done in backend-upgrade

export const getDrugProductDetailsByIdApiRoute = `${apiRoute}/pms/getDrugProductDetailsById`; // done in backend-upgrade

export const getDrugPBSDetailsByPBSCodeApiRoute = `${apiRoute}/pms/getDrugPBSDetailsByPBSCode`; // done in backend-upgrade

export const printHardCopyApiRoute = `${apiRoute}/pms/printHardCopy`; // done in backend-upgrade //! NOT TESTED YET

export const printEvidenceOfPrescriptionApiRoute = `${apiRoute}/pms/printEvidenceOfPrescription`; // done in backend-upgrade //! NOT TESTED YET

export const redoErxApiRoute = `${apiRoute}/pms/redoErx`; // done in backend-upgrade //! NOT TESTED YET

export const updateAttachmentInConsultNoteApiRoute = `${apiRoute}/pms/updateAttachmentInConsultNote`; //! No need to develop this - NOT Used on PMS
export const getAppointmentNumberNurse = `${apiRoute}/pms/getAppointMentNumberNurse`; // for nurse //! No need to develop this
export const getAppointmentNumberDoctor = `${apiRoute}/pms/getAppointMentNumber`; // for doctor // done in backend-upgrade //! NOT TESTED YET
export const bilableStateAPI = `${apiRoute}/pms/bilableStatus`; // is consult biable ? // done in backend-upgrade //! NOT TESTED YET
export const changeAppointmentStateAPI = `${apiRoute}/pms/ChangeAppointmentStatus`; // change appointment state // done in backend-upgrade //! NOT TESTED YET
export const checkPatientBalance = `${apiRoute}/pms/checkbalancePatient`; // before call start check patient card balance // done in backend-upgrade //! NOT TESTED YET
// export const makeACallAPI = `${apiRoute}/call/makeCall`;
export const makeACallAPI = `${apiRoute}/pms/makeCall`; // done in backend-upgrade //! NOT TESTED YET
export const cancleAppointmentAPI = `${apiRoute}/pms/AppointmentStatusUpdate`; // to cancle appointment // done in backend-upgrade //! NOT TESTED YET
export const changeBusyModeNurse = `${apiRoute}/nurse/changeBusyModePMS`; // for nurse //! NOT USING ANYMORE RELATED TO NURSE
export const changeBusyModeDoctor = `${apiRoute}/doctor/changeBusyModePMS`; // for doctor // done in backend-upgrade //! NOT TESTED YET
export const appointmentForDoctorDataAPI = `${apiRoute}/pms/AppointmentForDoctorData`; // appointment data interval // ! SEEMS LIKE NOT USING IT
export const appointmentPatientMissedDirectCallAPI = `${apiRoute}/pms/AppointmentPatientMissedDirectCall`; //? need to double check. I think we are not using. This API is just changing the status //! WE WILL CHECK DURING TESTING
export const appointmentForDoctor = `${apiRoute}/pms/GetAppointmentForDoctor`; // done in backend-upgrade //! NOT TESTED YET

export const getConsultNoteTemplatesApiRoute = `${apiRoute}/pms/getConsultNoteTemplates`; // done in backend-upgrade //! NOT TESTED YET
export const addConsultNoteTemplateApiRoute = `${apiRoute}/pms/addConsultNoteTemplate`; // done in backend-upgrade //! NOT TESTED YET
export const deleteConsultNoteTemplateApiRoute = `${apiRoute}/pms/deleteConsultNoteTemplate`; // done in backend-upgrade //! NOTE TESTED YET

export const getRadiologyRequestTemplatesApiRoute = `${apiRoute}/pms/templates/radiology`; // done in backend-upgrade //! NOT TESTED YET
export const addRadiologyRequestTemplateApiRoute = `${apiRoute}/pms/template/radiology`; // done in backend-upgrade //! NOT TESTED YET
export const deleteRadiologyRequestTemplateApiRoute = `${apiRoute}/pms/template/radiology/delete`; // done in backend-upgrade //! NOT TESTED YET

// re-authentication api
export const reAuthenticateApiRoute = `${apiRoute}/pms/reAuthenticate`; // ! ERX Requirement

// doctor pin authentication api
export const doctorPinAuthenticateApiRoute = `${apiRoute}/pms/doctorPinAuthenticate`; // ! API CODE WAS COMMENTED ON BACKEND.

// set pharmacy for a prescription, used for none or failed electronic prescribing
export const setPharmacyOfPrescriptionApiRoute = `${apiRoute}/pms/setPharmacyOfPrescription`; // done in backend-upgrade //! NOT TESTED YET

export const getDoctorProfile = `${apiRoute}/doctor/getProfile`; // done in backend-upgrade

// generate ePrescribing
export const generateEPrescribingApiRoute = `${apiRoute}/pms/generateEPrescribing`; // done in backend-upgrade  //! NOT FULLY TESTED YET - last time getting invalid IHI

// generate offline prescription
export const generateOfflinePrescriptionApiRoute = `${apiRoute}/pms/generateOfflinePrescription`; // done in backend-upgrade  //! NOT TESTED YET

export const getPathologyRequestTemplateAPI = `${apiRoute}/pms/getPathologyRequestTemplates`; // done in backend-upgrade  //! NOT TESTED YET
export const addPathologyRequestTemplateAPI = `${apiRoute}/pms/addPathologyRequestTemplate`; // done in backend-upgrade  //! NOT TESTED YET
export const deletePathologyRequestTemplateAPI = `${apiRoute}/pms/deletePathologyRequestTemplate`; // done in backend-upgrade  //! NOT TESTED YET

export const getReferralRequestTemplatesApiRoute = `${apiRoute}/pms/templates/referral`;
export const addReferralRequestTemplateApiRoute = `${apiRoute}/pms/template/referral`;
export const deleteReferralRequestTemplateApiRoute = `${apiRoute}/pms/template/referral/delete`;

// add dependent from admin
export const addDependentFromAdminAPI = `${apiRoute}/admin/dependent/add`; // done in backend-upgrade  //! NOT TESTED YET

/**
 * Instant Switch APIs
 */
export const sendInstantSwitchAttachmentsAPI = `${apiRoute}/admin/send/instantswitch/attachments`; // done in backend-upgrade  //! NOT TESTED YET

/**
 * Instant Hush APIs
 */
export const sendInstantHushAttachmentsAPI = `${apiRoute}/admin/send/instanthush/attachments`; // done in backend-upgrade  //! NOT TESTED YET

/**
 * ERX requirement for inactive session
 */
export const logoutApiRoute = `${apiRoute}/doctor/logoutFromAdmin`;

/**
 * MIMS V3
 */
export const API_MIMS_V3 = {
    SEARCH_DRUG: `${apiRoute}/mims/v3/search/drug`,
    PRODUCT_DETAILS: `${apiRoute}/mims/v3/search/product-detail`,
}
